import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { INBOX_STATES } from '../../pages/NotificationInbox/config';
import { useIsDesktop } from '../../utils/mediaQueries';
import styles from './styles';
const InboxTabMenu = ({ tabMenuState, updateParent, sectionName }) => {
    const { t } = useTranslation();
    const { UNREAD, READ } = INBOX_STATES;
    const isDesktop = useIsDesktop();
    const currentPillarName = window.location.href.split('/')[3] || ' ';
    const gaToggleAttributes = {
        'data-navigation-name': currentPillarName == 'goalsetting'
            ? 'Goals'
            : currentPillarName[0].toUpperCase() + currentPillarName.slice(1),
        'data-section-name': sectionName,
        'data-section-id': sectionName,
        'data-insight-id': 'Not applicable',
        'data-click-text': '',
        'data-type': 'Toggle',
    };
    // Toggles between the 2 inbox states
    const handleTabMenuStateChange = () => {
        const tab = tabMenuState === READ ? UNREAD : READ;
        updateParent(tab);
    };
    const ToggleButtonOption = (text, value) => (_jsx(ToggleButton, { sx: styles.toggleButton, value: value, disableRipple: true, "aria-label": text, ...gaToggleAttributes, 'data-click-text': t(text), children: _jsx(Typography, { variant: 'body1', children: t(text) }) }));
    return (_jsxs(ToggleButtonGroup, { sx: styles.toggleButtonGroup, value: tabMenuState, exclusive: true, onChange: handleTabMenuStateChange, "aria-label": 'Inbox type selector', fullWidth: !isDesktop ? true : false, children: [ToggleButtonOption(t(UNREAD), UNREAD), ToggleButtonOption(t(READ), READ)] }));
};
export default InboxTabMenu;
